import React from "react";
import { Footer } from "../../layout/Footer/Footer";

export const Loading = () => {
  return (
    <div className="exception-body error mt-8 p-2">
      <div className="exception-wrapper">
        <div className="exception-content">
          <div className="loader">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
